// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentRefundController = function ($scope, PaymentRefund, PUtill, PaymentRefundDownloadByFilter, DatepickerUtils) {
    $scope.wasSearching = false;
    $scope.dateRange = { dateFrom: null, dateTo: null };

    $scope.updateFilter = function (func) {
        $scope.refunds = $scope.paginator(function (options, callback) {
            return PaymentRefund.query(options, function() {
                callback(); $scope.wasSearching = options.search;
                if (func)
                    func();
                func = null;
            });
        }, getSearchParams(), 20);
    };

    $scope.statusName = PUtill.getText('Status');

    $scope.statusClass = function (status) {
        switch (status) {
            case 'Succeeded':
                return "label-success";
            case 'Failed':
                return "label-important";
            default:
                return '';
        }
    };

    var getSearchParams = function() {
        let searchParams = {
            search: $scope.search,
            dateFrom : $scope.dateRange.dateFrom,
            dateTo: PUtill.addDay($scope.dateRange.dateTo),
            status: null
        };

        if ($scope.status)
            searchParams.status = $scope.status;

        return searchParams;
    };
    $scope.downloadByFilter = function () {
        var searchParams = getSearchParams();
        searchParams.isDownload = true;
        var download = function () {
            $scope.isL = true;
            var downloadInfo = new PaymentRefundDownloadByFilter();
            downloadInfo.$save({
                isDownload: true,
                dateFrom: searchParams.dateFrom,
                dateTo: searchParams.dateTo,
                search: searchParams.search,
                status: searchParams.status
            }, function () {
                window.location = downloadInfo.Url;
                $scope.isL = false;
            }, function () { $scope.isL = false; });
        };
        $scope.updateFilter(download);
    };


    $scope.setStatus = function (status, defaultLabelName) {
        $scope.status = status.replace(' ', '');
        $scope.statusName = PUtill.getText(defaultLabelName || status);
        $scope.updateFilter();
    };

    $scope.filter = "";
    $scope.search = "";
    $scope.updateFilter();
};
PaymentRefundController.$inject = ['$scope', 'PaymentRefund', 'PUtill', 'PaymentRefundDownloadByFilter', 'DatepickerUtils'];
